/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clone from 'clone';
import moment from 'moment-timezone';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Dimmer,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
  Accordion,
  Table,
  Button,
  Label,
} from 'semantic-ui-react';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import BookingTitle from '../../../components/Bookings/BookingTitle';
import BOOKING_DEFAULT from '../../../structs/booking';
import { PaymentPlanModal } from '../../../components/PaymentPlan';
import amountToString, { spaFullNumber } from '../../../utils/amount';
import { decimalSum, decimalSub, decimalDiv } from '../../../utils/decimal';
import LoanAmount from '../../../components/LoanAmount';
import CurrencySymbol from '../../../components/CurrencySymbol';
import ArrowUpSvg from '../../../assets/icons/arrow-up.svg';
import ArrowDownSvg from '../../../assets/icons/arrow-down.svg';
import { isForeignCompany } from '../../../utils/companies';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

moment.locale('en-gb');

// NOTE: all the amount in this Payment Plan is not being rounded nearest.
// The responsibility of this component is just displaying what is returned from API

class PaymentPlan extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.shape(),
    }),
    onCheck: PropTypes.func,
    checkHasChanges: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        leadV2IsEnabled: PropTypes.bool,
      }),
    }),
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    fetchNewBooking: PropTypes.func,
    isMobile: PropTypes.bool,
    refetchBookingPaymentPlan: PropTypes.func,
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    return {
      data,
      loading,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const state = PaymentPlan.getPropsToState(props);
    this.state = {
      ...state,
      isOpenPaymentPlanModal: false,
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true,
      bookingPaymentPlan: {},
    };
    this.validation = {};
    this.loanBox = null;
  }
  componentDidMount() {
    if (this.state.data && this.state.data.id) {
      this.getBookingPaymentPlan(this.state.data.id);
    }
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = PaymentPlan.getPropsToState(nextProps);
    // don't allow state to override data if oriData is same
    const stateIsSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
    if (stateIsSame) {
      state.data = this.state.data;
    }

    this.setState({ ...state }, () => {
      if (!stateIsSame && state.data.id) {
        this.getBookingPaymentPlan(state.data.id);
      }
    });
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }));

  getCpsByDetailType = (cpss = [], type = 'downpayment') => _.filter(cpss, (cps) => {
    const { bookingPaymentPlan } = this.state;
    const bppds = bookingPaymentPlan ? bookingPaymentPlan.bookingPaymentPlanDetails : [];
    const psds = _.filter(bppds, (psd) => psd.id === cps.bookingPaymentPlanDetailID);
    return _.isEmpty(psds) ? false : psds[0].detailType === type;
  });

  getTransactionAmount = (cps) => this.amountToNumber(
    cps.transactionAmountDecimal,
    cps.transactionAmountFlat,
    cps.transactionAmountFull,
    cps.transactionAmountTimes,
  );

  getBookingPaymentPlan = async (bookingID) => {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/payment_plan/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        return;
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const cpss = data ? data.contractPaymentSchedules : [];
      const contractPaymentSchedules = this.sortContractPaymentSchedule(
        this.mapCpssWithBppdName(cpss, data),
      );
      this.setState({
        bookingPaymentPlan: {
          ...data,
          contractPaymentSchedules,
        },
      });
    }
    await this.setLoading(false);
  };

  getDownpaymentName = (bpp, bppdID, cpsName) => {
    const currBppd = _.find(bpp.bookingPaymentPlanDetails, (bppd) => bppd.id === bppdID);
    if (!currBppd) return '';
    const edited = !_.isEmpty(cpsName) && cpsName !== currBppd.downpaymentName;
    return edited ? cpsName : currBppd.downpaymentName;
  };

  mapCpssWithBppdName = (cpss = [], bpp) => _.map(cpss, (cps) => ({
    ...cps,
    name: this.getDownpaymentName(bpp, cps.bookingPaymentPlanDetailID, cps.name),
  })) || [];

  createBookingPaymentPlan = async (bookingPaymentPlan, bID) => {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bID}/payment_plan/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(bookingPaymentPlan),
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        return;
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await res.json();
      await store.dispatch(flashSuccessMessage({ message: 'Booking payment plan has been created successfully' }));
    }
    await this.setLoading(false);
  }

  updateBookingPaymentPlan = async (bookingPaymentPlan, bID) => {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bID}/payment_plan/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(bookingPaymentPlan),
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        return;
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await res.json();
      await store.dispatch(flashSuccessMessage({ message: 'Booking payment plan has been updated successfully' }));
    }
    await this.setLoading(false);
  }

  hasAccess = (check = false, admin = true, dhq = true, dbl = true, internal = false) => {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  };

  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const widthIsLessThan1200 = windowWidth < 1200;
    if (widthIsLessThan1200 !== this.state.widthIsLessThan1200) {
      state.widthIsLessThan1200 = widthIsLessThan1200;
    }
    const keys = Object.keys(state);
    if (keys.length > 0) {
      this.setState({ ...state });
    }
  };

  handleSetState = (state) => this.setState(prev => ({ ...prev, ...state }));

  handleToggle = (name) => this.handleSetState({ [name]: !this.state[name] });

  checkIsOddNumber = (number) => (number % 2) === 1;

  amountToNumber = (_decimal, _flat, _full, _times) => {
    const times = _times || 100;
    const amountStr = amountToString(_decimal, _flat, _full, _times);
    return parseFloat(amountStr).toFixed(times.toString().length - 1);
  };

  calculateTotalContractPaymentScheduleAmount = (cpss = []) => cpss.reduce((acc, curr) => {
    const {
      transactionAmountDecimal,
      transactionAmountFlat,
      transactionAmountFull,
      transactionAmountTimes,
    } = curr;
    const fixAmount = Number(this.amountToNumber(
      transactionAmountDecimal,
      transactionAmountFlat,
      transactionAmountFull,
      transactionAmountTimes,
    ));
    return decimalSum(acc, fixAmount);
  }, 0);

  sortContractPaymentScheduleBySeqNo = (cpss = []) => _.sortBy(cpss, 'sequenceNo');

  // categorized cps by detail type downpayment > instalment > development_stage
  // then sort by sequence no
  sortContractPaymentSchedule = (cpss = []) => {
    const cpssDownpayment = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'downpayment'));
    const cpssInstalment = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'instalment'));
    const cpssDevelopmentStage = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'development_stage'));
    return [...cpssDownpayment, ...cpssInstalment, ...cpssDevelopmentStage];
  };

  handleModalClose = () => this.handleSetState({
    isOpenPaymentPlanModal: false,
    isDownpaymentAccordionActive: true,
    isInstalmentAccordionActive: true,
  });

  handleCheckIsValidBookingStatus = (statusID) => _.some(
    ['reserved', 'booked', 'sold_spa_signed'],
    (s) => statusID === s,
  );

  handleSubmit = async (formBpp, bookingID) => {
    const { bookingPaymentPlan } = this.state;
    if (bookingPaymentPlan.id === formBpp.id) {
      await this.updateBookingPaymentPlan(formBpp, bookingID);
    } else {
      await this.createBookingPaymentPlan(formBpp, bookingID);
    }
    await this.getBookingPaymentPlan(bookingID);
    await this.props.refetchBookingPaymentPlan(bookingID);
    this.handleModalClose();
  };

  findDownpaymentName = (detailID, bppds = []) => {
    const curr = _.find(bppds, (bppd) => bppd.id === detailID);
    return curr ? curr.downpaymentName : '';
  };

  renderAmountWithCurrency = (amount, currency) => (
    <LoanAmount
      projectCurrencies={currency}
      format="0,000,000.00"
      amount={amount ? Number(amount).toFixed(2) : '0.00'}
      prefix={<CurrencySymbol />}
    />
  );

  renderAccordionToggle = (isActive) => (
    <img
      className="verticalAlign-mid"
      src={isActive ? ArrowUpSvg : ArrowDownSvg}
      alt={isActive ? 'collapse' : 'expand'}
    />
  );

  renderModals = (isLoading) => {
    const {
      oriData,
      isOpenPaymentPlanModal,
      bookingPaymentPlan,
    } = this.state;
    return (
      <div>
        <PaymentPlanModal
          open={isOpenPaymentPlanModal}
          loading={isLoading}
          bookingData={oriData}
          onClose={() => this.handleModalClose()}
          bookingPaymentPlan={bookingPaymentPlan}
          contractPaymentSchedules={
            bookingPaymentPlan && bookingPaymentPlan.contractPaymentSchedules
            ? bookingPaymentPlan.contractPaymentSchedules
            : []
          }
          isEdit={bookingPaymentPlan && bookingPaymentPlan.id !== ''} // is edit based on selectedPaymentPlan
          onSubmit={this.handleSubmit}
          token={this.props.token}
        />
      </div>
    );
  };

  renderEmptyNode = (isMalaysiaCompany, isValidBookingStatus) => {
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row className="emptyNodeRow">
          <Grid.Column width={16} textAlign="center">
            <div className="mb-8">{t('No payment plan added yet')}</div>
            <Label
              as="button"
              size="small"
              className="textButton"
              disabled={isMalaysiaCompany || !isValidBookingStatus}
              onClick={(event) => {
                event.preventDefault();
                this.handleToggle('isOpenPaymentPlanModal');
              }}
            >
              {t('Click here to add')}
            </Label>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderHeader = (isMobile, disabledEdit) => {
    const { t } = this.props;
    return (
      <Header className="new_title" as="h5" attached="top" textAlign="center">
        <Grid>
          <Grid.Column textAlign={isMobile ? 'left' : 'center'}>
            {t('Payment Plan').toUpperCase()}
            <div style={{ position: 'absolute', right: '1em', top: '1em' }}>
              <Button
                disabled={disabledEdit}
                onClick={() => this.handleToggle('isOpenPaymentPlanModal')}
                className="a-button-gray"
              >
                <Icon name="edit" fitted style={{ marginRight: '0.5rem' }} />
                {t('Edit', { ns: TRANSLATION_FILES.translation })}
              </Button>
            </div>
          </Grid.Column>
        </Grid>
      </Header>
    );
  }

  renderAccordion = ({ name, title, subtitle, content, isTogglable, id }) => (
    <Accordion fluid className="boxShadowAccordion" key={id}>
      <Accordion.Title
        active={isTogglable ? this.state[name] : true}
        {...isTogglable && ({ onClick: () => this.handleToggle(name) })}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <p className="text-header">{title}</p>
            </Grid.Column>
            {isTogglable && (
              <Grid.Column textAlign="right" width={4}>
                {this.renderAccordionToggle(isTogglable ? this.state[name] : true)}
              </Grid.Column>
            )}
          </Grid.Row>
          {subtitle && (
            <Grid.Row columns={1}>
              <Grid.Column>{subtitle}</Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </Accordion.Title>
      <Accordion.Content active={isTogglable ? this.state[name] : true}>
        {content}
      </Accordion.Content>
    </Accordion>
  );

  renderTable = ({ headers = [], rows = [] }) => {
    const { t } = this.props;
    return (
      <Table unstackable>
        <Table.Header>
          <Table.Row>
            {headers.map((h) => (
              <Table.HeaderCell key={h}>{t(h)}</Table.HeaderCell>
          ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows.map((row) => (
            <Table.Row key={row.id}>
              <Table.Cell width={4}>{row.name || '-'}</Table.Cell>
              <Table.Cell width={4}>{this.renderAmountWithCurrency(row.value) || '-'}</Table.Cell>
              <Table.Cell width={8}>{moment(row.billingAt).format('DD/MM/YYYY') || '-'}</Table.Cell>
            </Table.Row>
        ))}
        </Table.Body>
      </Table>
    );
  }

  renderSubtitle = (name, items = []) => (
    <Grid className="mt-4">
      {items.map((item, index) => (
        <Grid.Row key={`row_${name}_${index}`}>
          {Object.keys(item).map((key, idx) => {
            const isOddIndex = this.checkIsOddNumber(idx);
            const className = isOddIndex ? 'text-body' : 'text-title';
            return (
              <Grid.Column mobile={8} tablet={4} largeScreen={4} computer={4} key={key}>
                <span className={className}>{item[key]}</span>
              </Grid.Column>
            );
          })}
        </Grid.Row>
      ))}
    </Grid>
  );

  render() {
    const { isMobile, auth, t } = this.props;
    const { loading, data, bookingPaymentPlan } = this.state;
    const bookingPaymentPlanDetails = bookingPaymentPlan
      ? bookingPaymentPlan.bookingPaymentPlanDetails
      : [];
    const cpss = bookingPaymentPlan ? bookingPaymentPlan.contractPaymentSchedules : [];
    const isValidBookingStatus = this.handleCheckIsValidBookingStatus(data.statusID);
    const isMalaysiaCompany = !isForeignCompany(auth.company);

    const currency = data.project.projectCurrency;
    const spaPrice = Number(spaFullNumber(data));
    const depositAmount = parseFloat(data.paymentAmount);

    // downpayment
    const cpsDownpayments = this.getCpsByDetailType(cpss);
    const cpsTotalDownpayments = this.calculateTotalContractPaymentScheduleAmount(cpsDownpayments);

    // instalment
    const cpsInstalments = this.getCpsByDetailType(cpss, 'instalment');
    const cpsTotalInstalments = this.calculateTotalContractPaymentScheduleAmount(cpsInstalments);
    const bookingPaymentPlanDetailInstalment = _.find(bookingPaymentPlanDetails, (psd) => psd.detailType === 'instalment');
    // total instalment = spaPrice - deposit - total downpayment
    const totalInstalmentAmount = decimalSub(
      decimalSub(spaPrice, depositAmount),
      cpsTotalDownpayments,
    );
    const instalmentPerMonth = bookingPaymentPlanDetailInstalment
      ? decimalDiv(totalInstalmentAmount, bookingPaymentPlanDetailInstalment.detailInstalmentCount)
      : totalInstalmentAmount;

    const noContent = (_.isEmpty(cpsDownpayments) && _.isEmpty(cpsInstalments));

    const accordionOptions = [
      {
        id: 'paymentPlanInformation',
        isTogglable: false,
        title: t('Payment plan information'),
        content: this.renderSubtitle('paymentPlan', [{
          sellingPrice: t('Selling Price'),
          sellingPriceValue: this.renderAmountWithCurrency(spaPrice, currency),
          paymentPlanName: t('Payment Plan'),
          paymentPlanNameValue: bookingPaymentPlan ? bookingPaymentPlan.code : '',
        }, {
          depositAmount: t('Deposit Amount'),
          depositAmountValue: this.renderAmountWithCurrency(depositAmount, currency),
        }]),
      },
    ];

    if (!_.isEmpty(cpsDownpayments)) {
      accordionOptions.push({
        id: 'downpaymentInformation',
        name: 'isDownpaymentAccordionActive',
        isTogglable: true,
        title: t('Downpayment'),
        subtitle: this.renderSubtitle('downpayment', [{
          totalDownpaymentAmount: t('Total downpayment'),
          totalDownpaymentAmountValue: this.renderAmountWithCurrency(
            cpsTotalDownpayments,
            currency,
          ),
          downpaymentCount: t('Number of downpayments'),
          downpaymentCountValue: _.size(cpsDownpayments) || 0,
        }]),
        content: this.renderTable({
          headers: ['Downpayment name', 'Value', 'Billing date'],
          rows: _.map(cpsDownpayments, (d) => ({
            id: d.id,
            name: this.findDownpaymentName(
              d.bookingPaymentPlanDetailID,
              bookingPaymentPlan.bookingPaymentPlanDetails,
            ),
            billingAt: d.transactionDate,
            value: this.getTransactionAmount(d),
          })),
        }),
      });
    }

    if (!_.isEmpty(cpsInstalments)) {
      accordionOptions.push({
        id: 'instalmentInformation',
        name: 'isInstalmentAccordionActive',
        isTogglable: true,
        title: t('Instalment'),
        subtitle: this.renderSubtitle('instalment', [{
          totalInstalment: t('Total instalment'),
          totalInstalmentValue: this.renderAmountWithCurrency(cpsTotalInstalments, currency),
          instalmentCount: t('Number of instalments'),
          instalmentCountValue: _.size(cpsInstalments) || 0,
        }, {
          instalmentPerMonth: t('Average instalment per month'),
          instalmentPerMonthValue: this.renderAmountWithCurrency(instalmentPerMonth, currency),
          nextBillingDate: t('Next billing date'),
          nextBillingDateValue: moment(cpsInstalments[0].transactionDate).format('DD/MM/YYYY'),
        }, {
          lastInstalment: t('Last instalment'),
          lastInstalmentValue: this.renderAmountWithCurrency(
            this.getTransactionAmount(cpsInstalments[_.size(cpsInstalments) - 1]),
            currency,
          ),
        }]),
        content: this.renderTable({
          headers: ['Downpayment name', 'Value', 'Billing date'],
          rows: _.map(cpsInstalments, (d, idx) => ({
            id: d.id,
            name: `${t('Instalment')} ${idx + 1}`,
            billingAt: d.transactionDate,
            value: this.getTransactionAmount(d),
          })),
        }),
      });
    }

    return (
      <Container className="paymentPlan">
        {this.renderModals(loading)}
        <BookingTitle isMobile={isMobile} data={data} />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
              <div>
                {this.renderHeader(
                  isMobile,
                  noContent || isMalaysiaCompany || !isValidBookingStatus,
                )}
                <Segment attached>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {
                          bookingPaymentPlan && bookingPaymentPlan.id !== ''
                            ? accordionOptions.map((item) => this.renderAccordion(item))
                            : this.renderEmptyNode(isMalaysiaCompany, isValidBookingStatus)
                        }
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(PaymentPlan.mapStateToProps)(PaymentPlan));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/PaymentPlan.jsx